import React, { useState } from "react";
import { Button } from "react-bootstrap";
import styled from "styled-components";
import { EmailSubscribeForm } from "../forms/email-subscribe-form";

const FloatingContainer = styled("div")({
  position: "fixed",
  bottom: "15px",
  right: "25px",
  zIndex: 20,
});

export const FloatingSubscribeButton: React.FC = () => {
  const [collapsed, setCollapsed] = useState(true);
  const [didSubscribe, setDidSubscribe] = useState(false);

  if (didSubscribe && collapsed) {
    return <></>;
  }

  return (
    <FloatingContainer>
      {collapsed ? (
        <Button className="big-shadow" onClick={() => setCollapsed(false)}>
          Tilmeld nyhedsbrev
        </Button>
      ) : (
        <div className="p-3 bg-white big-shadow">
          <div className="d-flex align-items-center justify-content-between pb-3">
            <h5 className="my-0 mr-5">
              {!didSubscribe ? <>Modtag gratis nyheder</> : <></>}
            </h5>
            <button
              type="button"
              onClick={() => setCollapsed(true)}
              className="close text-primary"
              style={{ opacity: 1 }}
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <EmailSubscribeForm
            location="floating"
            hasAutofocus={true}
            onSubscribed={() => setDidSubscribe(true)}
          />
        </div>
      )}
    </FloatingContainer>
  );
};
